import React, {useState} from "react";
import {DatePicker, Form, Input, Modal, Select, Tooltip} from "antd";
import {useStore} from "hooks/useStore";
import moment from "moment";
import {EXIT_REASONS, TERMINATION_TYPES} from "./courierLifecycleConstants";
import locale from "antd/es/date-picker/locale/tr_TR";
import {InfoCircleOutlined} from "@ant-design/icons";

export const SendToEvaluationModal = ({visible, onClose, courierId, onSuccess}) => {
    const stores = useStore();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            const result = await stores.courierStore.sendToEvaluation(courierId, {
                ...values,
                noticeEndDate: values.noticeEndDate?.format("YYYY-MM-DD"),
                reportedQuitDate: moment().format("YYYY-MM-DD")
            });
            if (result.success) {
                form.resetFields();
                onClose();
                onSuccess();
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            title="Değerlendirmeye Gönder"
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Değerlendirmeye Gönder"
            cancelText="İptal"
            confirmLoading={loading}
            width={600}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="terminationType"
                    label="Fesih Durumu"
                    rules={[{required: true, message: "Fesih durumu zorunludur"}]}
                >
                    <Select placeholder="Fesih durumu seçin" options={TERMINATION_TYPES} />
                </Form.Item>
                <Form.Item
                    name="reason"
                    label="Çıkış Nedeni"
                    rules={[{required: true, message: "Çıkış nedeni zorunludur"}]}
                >
                    <Select placeholder="Çıkış nedeni seçin" options={EXIT_REASONS} />
                </Form.Item>
                <Form.Item
                    name="noticeEndDate"
                    label="İhbar Bitiş Tarihi"
                    rules={[{required: true, message: "İhbar bitiş tarihi zorunludur"}]}
                >
                    <DatePicker style={{width: "100%"}} format="DD.MM.YYYY" locale={locale} />
                </Form.Item>
                <Form.Item
                    label={
                        <span>
                            Bildirilen Çıkış Tarihi
                            <Tooltip title="Bildirilen çıkış tarihi otomatik olarak bugünün tarihiyle doldurulur ve değiştirilemez.">
                                <InfoCircleOutlined style={{marginLeft: 4}} />
                            </Tooltip>
                        </span>
                    }
                >
                    <Input readOnly style={{width: "100%"}} value={moment().format("DD.MM.YYYY")} />
                </Form.Item>
                <Form.Item
                    name="noticeDeduction"
                    label="İhbar Kesintisi Olacak Mı?"
                    rules={[{required: true, message: "Bu alan zorunludur"}]}
                >
                    <Select placeholder="Seçin">
                        <Select.Option value={true}>Evet</Select.Option>
                        <Select.Option value={false}>Hayır</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    name="operationNote"
                    label="Çıkış Açıklaması (Operasyon)"
                    rules={[{required: true, message: "Çıkış açıklaması zorunludur"}]}
                >
                    <Input.TextArea rows={3} />
                </Form.Item>
            </Form>
        </Modal>
    );
};
